import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01bc8412"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-width":"88%"} }
const _hoisted_2 = { class: "text-h6 ellipsis" }
const _hoisted_3 = { class: "row q-col-gutter-md" }
const _hoisted_4 = { class: "col" }

import {
  computed,
  ref,
  toRefs,
  withDefaults,
} from 'vue';
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import useQuasar from 'quasar/src/composables/use-quasar.js';;
import Tooltip from '@/common/Tooltip/Tooltip.vue';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import/no-cycle
import { ActionTwoButtons, DialogEventType } from '.';
import { DialogWidth } from './types/dialogWidth.type';


export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
    title: {},
    width: { default: DialogWidth.narrow },
    contentMinWidth: {},
    contentStyle: { default: '' },
    disabledSaveBtn: { type: Boolean },
    loadingSaveData: { type: Boolean },
    loadingGetData: { type: Boolean },
    loadingDestroy: { type: Boolean },
    fullscreen: { type: Boolean, default: false },
    saveLabelBtn: {},
    cancelLabelBtn: {},
    destroyLabelBtn: {},
    hideDestroyButton: { type: Boolean, default: true },
    iconDestroyButton: { default: 'mdi-delete' },
    isShowButtons: { type: Boolean, default: true },
    titleDialogConfirm: {},
    messageDialogConfirm: {}
  },
  emits: [
  'onOk',
  'onCancel',
  'onDestroy',
  'onClickFullscreen',
],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t } = useI18n();



const {
  dialogRef, onDialogHide, onDialogCancel, onDialogOK,
} =	useDialogPluginComponent();

const saveLabel = computed(() => props.saveLabelBtn ?? t('save'));
const cancelLabel = computed(() => props.cancelLabelBtn ?? t('cancel'));
const destroyLabel = computed(() => props.destroyLabelBtn ?? t('destroy'));

const { width } = toRefs(props);

const dialogEvents: DialogEventType<any> = {
  onDialogHide,
  onDialogCancel,
  onDialogOK,
};



const $q = useQuasar();
const fullscreen = ref(props.fullscreen || $q.screen.sm || $q.screen.xs);

const expandStatic = ref(true);

const fullWidthStyle = computed(() => (fullscreen.value
  ? ''
  : `width: ${isNaN(width.value) ? DialogWidth[width.value] : width.value}px; max-width: 80vw;`));

const handlerClickFullscreen = () => {
  fullscreen.value = !fullscreen.value;
  emits('onClickFullscreen', fullscreen.value);
};

const scrollAreaClass = computed(() => (
  // eslint-disable-next-line no-nested-ternary
  $q.screen.lt.md
    ? expandStatic.value
      ? 'scroll-area-block-ltmd-expanded'
      : 'scroll-area-block-ltmd'
    : 'scroll-area-block'));

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    maximized: fullscreen.value,
    "no-backdrop-dismiss": "",
    "no-esc-dismiss": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        style: _normalizeStyle(fullWidthStyle.value),
        class: "q-dialog-plugin wrapper-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "flex justify-between flex-center q-pa-sm q-pl-md bg-primary text-white shadow-1" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
              ]),
              _createElementVNode("div", null, [
                (!(_unref($q).screen.sm || _unref($q).screen.xs))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      icon: fullscreen.value ? 'minimize' : 'fullscreen',
                      flat: "",
                      round: "",
                      onClick: handlerClickFullscreen
                    }, {
                      default: _withCtx(() => [
                        _createVNode(Tooltip, {
                          title: fullscreen.value ? _ctx.$t('dialog.exitFullscreen') : _ctx.$t('dialog.fullscreen'),
                          position: "bottom"
                        }, null, 8, ["title"])
                      ]),
                      _: 1
                    }, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  flat: "",
                  icon: "close",
                  round: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onCancel', dialogEvents)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(Tooltip, {
                      title: _ctx.$t('close'),
                      position: "bottom"
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_section, {
            class: _normalizeClass([fullscreen.value ? 'content-block-fullscreen' : 'content-block', "scroll"]),
            style: _normalizeStyle(_ctx.contentStyle)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (!!_ctx.$slots.staticBlock)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(_unref($q).screen.lt.md ? 'col-12' : 'col'),
                      style: _normalizeStyle(
              _unref($q).screen.lt.md
                ? expandStatic.value
                  ? { height: '200px' }
                  : { height: '56px' }
                : ''
            )
                    }, [
                      (_unref($q).screen.lt.md)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            icon: expandStatic.value ? 'unfold_less' : 'unfold_more',
                            class: "btn-expand q-ma-lg",
                            color: "primary",
                            dense: "",
                            round: "",
                            size: "sm",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (expandStatic.value = !expandStatic.value))
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      _renderSlot(_ctx.$slots, "staticBlock")
                    ], 6))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  (!!_ctx.$slots.staticBlock)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(
                fullscreen.value ? 'scroll-area-block-fullscreen' : scrollAreaClass.value
              ),
                        style: {"overflow-y":"auto"}
                      }, [
                        _renderSlot(_ctx.$slots, "content", { dialogEvents: dialogEvents }, () => [
                          _renderSlot(_ctx.$slots, "default")
                        ])
                      ], 2))
                    : _renderSlot(_ctx.$slots, "content", {
                        key: 1,
                        dialogEvents: dialogEvents
                      }, () => [
                        _renderSlot(_ctx.$slots, "default")
                      ])
                ])
              ]),
              _renderSlot(_ctx.$slots, "loading", {}, () => [
                _createVNode(_component_q_inner_loading, {
                  showing: _ctx.loadingSaveData || _ctx.loadingGetData
                }, null, 8, ["showing"])
              ])
            ]),
            _: 3
          }, 8, ["class", "style"]),
          _createElementVNode("div", null, [
            _createVNode(_component_q_separator),
            (_ctx.isShowButtons)
              ? _renderSlot(_ctx.$slots, "actions", {
                  key: 0,
                  dialogEvents: dialogEvents
                }, () => [
                  _createVNode(_unref(ActionTwoButtons), {
                    "disabled-destroy-button": _ctx.loadingGetData || _ctx.loadingSaveData,
                    "disabled-second-button": _ctx.loadingDestroy || _ctx.disabledSaveBtn,
                    "hide-destroy-button": _ctx.hideDestroyButton,
                    "label-destroy-button": destroyLabel.value,
                    "icon-destroy-button": _ctx.iconDestroyButton,
                    "label-first-button": cancelLabel.value,
                    "label-second-button": saveLabel.value,
                    "loading-second-button": _ctx.loadingSaveData,
                    "title-dialog-confirm": _ctx.titleDialogConfirm,
                    "message-dialog-confirm": _ctx.messageDialogConfirm,
                    onClickDestroyButton: _cache[2] || (_cache[2] = ($event: any) => (emits('onDestroy', dialogEvents))),
                    onClickFirstButton: _cache[3] || (_cache[3] = ($event: any) => (emits('onCancel', dialogEvents))),
                    onClickSecondButton: _cache[4] || (_cache[4] = ($event: any) => (emits('onOk', dialogEvents)))
                  }, null, 8, ["disabled-destroy-button", "disabled-second-button", "hide-destroy-button", "label-destroy-button", "icon-destroy-button", "label-first-button", "label-second-button", "loading-second-button", "title-dialog-confirm", "message-dialog-confirm"])
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["style"])
    ]),
    _: 3
  }, 8, ["maximized"]))
}
}

})